(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 75557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(44369);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


const NebhamPage = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 505).then(__webpack_require__.bind(__webpack_require__, 24505)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(24505)
            ]
    },
    ssr: false
});
/* harmony default export */ __webpack_exports__["Z"] = (NebhamPage);


/***/ }),

/***/ 44369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _cloudscape_design_components_box__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31927);
/* harmony import */ var _cloudscape_design_components_space_between__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99615);
/* harmony import */ var _components_CustomPage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95885);





function Home() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CustomPage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        pageHref: "/",
        breadcrumbs: [
            {
                text: "Home",
                href: "#"
            },
            {
                text: "Dashboard",
                href: "#"
            }
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_space_between__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            size: "xxs",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    marginTop: 20
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "h2",
                        color: "inherit",
                        children: "Welcome to Nebham Hub"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cloudscape_design_components_box__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "p",
                        color: "inherit",
                        children: "One-Stop Platform to manage products, inventory, receive orders, fulfill shipments, and more."
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 31927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74118);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33903);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26633);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function Box(_a) {
    var _b = _a.variant, variant = _b === void 0 ? "div" : _b, _c = _a.margin, margin = _c === void 0 ? {} : _c, _d = _a.padding, padding = _d === void 0 ? {} : _d, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "variant",
        "margin",
        "padding"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("Box");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({
        variant: variant,
        margin: margin,
        padding: padding
    }, props, baseComponentProps));
}
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__/* .applyDisplayName */ .b)(Box, "Box"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 99615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpaceBetween; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74118);
/* harmony import */ var _internal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15231);
/* harmony import */ var _internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26633);

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0




function SpaceBetween(_a) {
    var _b = _a.direction, direction = _b === void 0 ? "vertical" : _b, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, [
        "direction"
    ]);
    var baseComponentProps = (0,_internal_hooks_use_base_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("SpaceBetween");
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({
        direction: direction
    }, props, baseComponentProps));
}
(0,_internal_utils_apply_display_name__WEBPACK_IMPORTED_MODULE_4__/* .applyDisplayName */ .b)(SpaceBetween, "SpaceBetween"); //# sourceMappingURL=index.js.map


/***/ }),

/***/ 15231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InternalSpaceBetween; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@cloudscape-design/components/internal/base-component/index.js + 1 modules
var base_component = __webpack_require__(61903);
// EXTERNAL MODULE: ./node_modules/@cloudscape-design/components/space-between/styles.scoped.css
var styles_scoped = __webpack_require__(18850);
;// CONCATENATED MODULE: ./node_modules/@cloudscape-design/components/space-between/styles.css.js

/* harmony default export */ var styles_css = ({
    "root": "awsui_root_18582_66aol_93",
    "child": "awsui_child_18582_66aol_97",
    "horizontal": "awsui_horizontal_18582_66aol_108",
    "horizontal-xxxs": "awsui_horizontal-xxxs_18582_66aol_112",
    "horizontal-xxs": "awsui_horizontal-xxs_18582_66aol_116",
    "horizontal-xs": "awsui_horizontal-xs_18582_66aol_120",
    "horizontal-s": "awsui_horizontal-s_18582_66aol_124",
    "horizontal-m": "awsui_horizontal-m_18582_66aol_128",
    "horizontal-l": "awsui_horizontal-l_18582_66aol_132",
    "horizontal-xl": "awsui_horizontal-xl_18582_66aol_136",
    "horizontal-xxl": "awsui_horizontal-xxl_18582_66aol_140",
    "child-horizontal-xxxs": "awsui_child-horizontal-xxxs_18582_66aol_145",
    "child-horizontal-xxs": "awsui_child-horizontal-xxs_18582_66aol_151",
    "child-horizontal-xs": "awsui_child-horizontal-xs_18582_66aol_157",
    "child-horizontal-s": "awsui_child-horizontal-s_18582_66aol_163",
    "child-horizontal-m": "awsui_child-horizontal-m_18582_66aol_169",
    "child-horizontal-l": "awsui_child-horizontal-l_18582_66aol_175",
    "child-horizontal-xl": "awsui_child-horizontal-xl_18582_66aol_181",
    "child-horizontal-xxl": "awsui_child-horizontal-xxl_18582_66aol_187",
    "vertical": "awsui_vertical_18582_66aol_196",
    "child-vertical-xxxs": "awsui_child-vertical-xxxs_18582_66aol_200",
    "child-vertical-xxs": "awsui_child-vertical-xxs_18582_66aol_204",
    "child-vertical-xs": "awsui_child-vertical-xs_18582_66aol_208",
    "child-vertical-s": "awsui_child-vertical-s_18582_66aol_212",
    "child-vertical-m": "awsui_child-vertical-m_18582_66aol_216",
    "child-vertical-l": "awsui_child-vertical-l_18582_66aol_220",
    "child-vertical-xl": "awsui_child-vertical-xl_18582_66aol_224",
    "child-vertical-xxl": "awsui_child-vertical-xxl_18582_66aol_228"
});

// EXTERNAL MODULE: ./node_modules/react-keyed-flatten-children/index.js
var react_keyed_flatten_children = __webpack_require__(23262);
;// CONCATENATED MODULE: ./node_modules/@cloudscape-design/components/space-between/internal.js

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0





function InternalSpaceBetween(_a) {
    var _b = _a.direction, direction = _b === void 0 ? "vertical" : _b, size = _a.size, children = _a.children, __internalRootRef = _a.__internalRootRef, props = (0,tslib_es6/* __rest */._T)(_a, [
        "direction",
        "size",
        "children",
        "__internalRootRef"
    ]);
    var baseProps = (0,base_component/* getBaseProps */.j)(props);
    /*
     Flattening the children allows us to "see through" React Fragments and nested arrays.
     */ var flattenedChildren = (0,react_keyed_flatten_children/* default */.Z)(children);
    return /*#__PURE__*/ react.createElement("div", (0,tslib_es6/* __assign */.pi)({}, baseProps, {
        className: (0,clsx_m/* default */.Z)(baseProps.className, styles_css.root, styles_css[direction], styles_css["".concat(direction, "-").concat(size)]),
        ref: __internalRootRef
    }), flattenedChildren.map(function(child) {
        // If this react child is a primitive value, the key will be undefined
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var key = child.key;
        return /*#__PURE__*/ react.createElement("div", {
            key: key,
            className: (0,clsx_m/* default */.Z)(styles_css.child, styles_css["child-".concat(direction, "-").concat(size)])
        }, child);
    }));
} //# sourceMappingURL=internal.js.map


/***/ }),

/***/ 18850:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 23262:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
/* Returns React children into an array, flattening fragments. */
var react_1 = __webpack_require__(67294);
var react_is_1 = __webpack_require__(59864);
function flattenChildren(children, depth, keys) {
    if (depth === void 0) { depth = 0; }
    if (keys === void 0) { keys = []; }
    return react_1.Children.toArray(children).reduce(function (acc, node, nodeIndex) {
        if (react_is_1.isFragment(node)) {
            acc.push.apply(acc, flattenChildren(node.props.children, depth + 1, keys.concat(node.key || nodeIndex)));
        }
        else {
            if (react_1.isValidElement(node)) {
                acc.push(react_1.cloneElement(node, {
                    key: keys.concat(String(node.key)).join('.')
                }));
            }
            else if (typeof node === "string" || typeof node === "number") {
                acc.push(node);
            }
        }
        return acc;
    }, []);
}
exports.Z = flattenChildren;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(75557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);